export default {
    it: {
        "question": "Rileggi ed eventualmente modifica la domanda che vuoi porre",
        "remaining-characters": "Ti rimangono: ",
        "characters": " caratteri",
        "question-custom": "Scrivi la tua domanda",
        "question_amm": "Motivazione della richiesta"
    },
    en: {
        "question": "Reread and, if necessary, modify the question you want to ask.",
        "remaining-characters": "You have ",
        "characters": " characters",
        "question-custom": "Write your question",
        "question_amm": "Request's motivation"

    }
}